import React, { ReactNode } from 'react';
import BootstrapModal from 'react-bootstrap/Modal';

interface ModalBodyProps {
    children: ReactNode;
}

export const ModalBody = ({ children }: ModalBodyProps) => <BootstrapModal.Body>{children}</BootstrapModal.Body>;
